import { useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { ITask } from "dto/ITask";
import TaskModal from "components/TaskModal";
import { IStatus } from "dto/IStatus";
import { ITag } from "dto/ITag";
import { IEntity } from "dto/IEntity";
import TasksListNew from "components/TasksListNew";

export interface IFILTERTASK {
  status: IStatus;
  tag: ITag;
  assignedTo: IEntity;
  assignedBy: IEntity;
  startDate: Date;
  endDate: Date;
}

const Tasks: FC<Props> = ({ search, isDesk }) => {
  const [task, setTask] = useState<ITask | null>(null);

  // if (task) {
  //   return (
  //     <div className={`${styles.listWrapper}`}>
  //       <Task setTask={setTask} task={task} />
  //       <TaskFilter isOpen={!isCases} task={task} setTask={setTask} />
  //     </div>
  //   );
  // }

  return (
    <>
      <div className={`${styles.listWrapper}`}>
        <TasksListNew
          search={search}
          isDesk={isDesk}
          setTask={setTask}
          showToolbar={!isDesk}
          hideColumnHeader={isDesk}
        />
        {/* <TaskFilter isOpen={!isCases} setFilters={setFilters} /> */}
      </div>
      {task && <TaskModal setTask={setTask} task={task} />}
    </>
  );
};

export default Tasks;
